<template>
  <div>
    <swiper
      v-if="!!images.length"
      :modules="modules"
      :slides-per-view="1"
      :navigation="{nextEl: '#button-next',prevEl: '#button-prev'}"
      :pagination="{ clickable: true, type: 'bullets' }"
      @swiper="setFirstSwiper"
      :controller="{ control: secondSwiper }"
      :thumbs="{ swiper: thumbsSwiper }"
    >
      <swiper-slide v-for="image in images" style=" cursor: pointer;">
        <img
          data-bs-toggle="modal" data-bs-target="#swiperModal"
          :src="imageSrc(image)"
          class="card-img img-fluid"
          alt="...">
        <div
          style="position: absolute;z-index: 3000;top: 20px;right: 20px;font-size: 30px;"
          data-bs-toggle="modal" data-bs-target="#swiperModal"
        >
          <i class="fa-solid fa-magnifying-glass"></i>
        </div>
      </swiper-slide>
      <div id="button-next" class="swiper-button-next">
        <img src="/themes/default/images/icons/right-arrow.png" alt="right arrow">
      </div>
      <div id="button-prev" class="swiper-button-prev">
        <img src="/themes/default/images/icons/left-arrow.png" alt="left arrow">
      </div>
    </swiper>
    <div v-else>
      <img
        src="/images/cars/no_image.jpg"
        class="img-fluid card-img"
        alt="car"
      />
    </div>
<!--    Modal -->
    <div class="modal fade " id="swiperModal" tabindex="-1" aria-labelledby="swiperModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content" style="background-color: inherit; border: 0">
          <div class="modal-body" style="padding: 0">
            <swiper
              :modules="[Controller, Navigation]"
              watch-slides-progress
              @swiper="setSecondSwiper"
              :controller="{ control: firstSwiper }"
              :navigation="{nextEl: '#button-next',prevEl: '#button-prev'}"
            >
              <div style="right: 20px; left: auto; top: 20px;position: absolute;cursor: pointer;display: flex;    z-index: 10;">
              <button
                type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Lukk"></button>
              </div>
              <swiper-slide v-for="image in images">
                <img
                  :src="imageSrc(image)"
                  class="card-img img-fluid"
                  style="border-radius:0"
                  alt="...">
              </swiper-slide>
              <div id="button-next" class="swiper-button-next">
                <img src="/themes/default/images/icons/right-arrow.png" alt="right arrow">
              </div>
              <div id="button-prev" class="swiper-button-prev">
                <img src="/themes/default/images/icons/left-arrow.png" alt="left arrow">
              </div>
            </swiper>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Navigation, Pagination, A11y, Thumbs, Virtual, Controller} from 'swiper';

import {Swiper, SwiperSlide} from 'swiper/vue';
import {ref} from 'vue';

// Import Swiper styles
import 'swiper/css/bundle';

export default {
  props: ['prop_images'],
  components: {
    Swiper,
    SwiperSlide,
    Thumbs,
  },
  directives: {
    //swiper: directive
  },
  setup() {
    const firstSwiper = ref(null);
    const secondSwiper = ref(null);
    const setFirstSwiper = (swiper) => {
      firstSwiper.value = swiper;
    };
    const setSecondSwiper = (swiper) => {
      secondSwiper.value = swiper;
    };

    return {
      modules: [Navigation, Pagination, A11y, Thumbs, Virtual, Controller],
      Thumbs,
      Navigation,
      Controller,
      firstSwiper,
      secondSwiper,
      setFirstSwiper,
      setSecondSwiper,
    };
  },
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '#button-next',
          prevEl: '#button-prev'
        },
        // Some Swiper option/callback...
      },

      images: []
    }
  },

  mounted() {
    this.images = JSON.parse(this.prop_images)
  },

  methods: {
    imageSrc(image) {
      return image.url ? image.url : '/storage/' + image.path;
    },
  },
}
</script>
<style scoped>
.img-container {
  height: 50%;
}

.img-container .img-responsive {
  display: block;
  width: auto;
  max-height: 50%;
}
</style>



